import i18n from '@/i18n/i18n'
import SupplierCurrentAccount from '@/services/admin/SupplierCurrentAccount'
import { errorMessage, build_query } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = [
  'created_between',
  'activity_date_between',
  'subject_type',
  'subject_no',
  'convert_amount_for_filter'
]

export const namespaced = true

export const state = {
  supplierCurrentAccountActivities: [],
  balance: null,
  meta: null
}

export const mutations = {
  SET_BALANCE(state, account) {
    state.balance = account.data
  },
  SET_SUPPLIER_CURRENT_ACCOUNT_ACTIVITIES(state, account) {
    state.supplierCurrentAccountActivities = account.data
    state.meta = account.meta
  }
}

export const actions = {
  getSupplierCurrentAccount({ commit, dispatch }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierCurrentAccount.getSupplierCurrentAccountBalance(supplier)
        .then(response => {
          commit('SET_BALANCE', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getSupplierCurrentAccountActivities({ commit, dispatch }, supplier) {
    let newQuery = build_query(supplier.query, allowedFilters)

    return new Promise((resolve, reject) => {
      SupplierCurrentAccount.getSupplierCurrentAccountActivities(supplier.supplierId, newQuery)
        .then(response => {
          commit('SET_SUPPLIER_CURRENT_ACCOUNT_ACTIVITIES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSupplierCurrentAccountActivity({ commit, dispatch }, newActivities) {
    return new Promise((resolve, reject) => {
      SupplierCurrentAccount.createSupplierCurrentAccountActivity(
        newActivities.supplierId,
        newActivities.accountActivities
      )
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportSupplierCurrentAccount({ commit, dispatch }, supplier) {
    let newQuery = build_query(supplier.query, allowedFilters)

    return new Promise((resolve, reject) => {
      SupplierCurrentAccount.exportSupplierCurrentAccount(supplier.parameter, newQuery)
        .then(response => {
          resolve(response)
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: t('store.admin.suppliers.supplier_current_table')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.exporting_error', {
                element: t('store.admin.suppliers.supplier_current_table')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
